/**
 * The single font stack of the application.
 *
 * It exists as a constant because the fallback is no longer decorative. Poppins is self-hosted with
 * `font-display: swap` (`src/styles/fonts.css`), so on a cold load the browser paints text in
 * whatever comes after 'Poppins' here and repaints when the file lands - on the measured production
 * tenant the fonts arrive around a second after first paint, so that fallback is always on screen
 * for a moment. A stack written by hand at each call site drifts, and a site that omits the
 * fallback entirely falls back to the browser default, which is a serif.
 *
 * The order is the platform's own UI face first - San Francisco, Segoe UI, Roboto - because it is
 * already loaded and is the closest sans-serif the device has. Arial is the cross-platform floor.
 *
 * Metric overrides (`size-adjust`, `ascent-override`) would shrink the reflow further by matching
 * the fallback's metrics to Poppins. That is a separate, measurable change; this constant is what
 * makes it a one-line change when it happens.
 */
const FONT_FAMILY =
  "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif";

export default FONT_FAMILY;
